module.exports = __webpack_public_path__ + "img/icon-thumbs-up.bef918be.svg";